module.exports = __webpack_public_path__ + "img/9791160510102.006ecefa.jpg";